/**
 * Convert 24hr time string "HH:MM" to 12hr "h:MM AM/PM".
 * Returns the original string on error.
 */
export const formatTime12hr = (time) => {
  if (!time) return '';
  try {
    const parts = String(time).split(':');
    const h = parseInt(parts[0], 10);
    const m = parts[1] || '00';
    const ampm = h >= 12 ? 'PM' : 'AM';
    const h12 = h % 12 || 12;
    return `${h12}:${m} ${ampm}`;
  } catch {
    return String(time);
  }
};
